import type { Member } from '$lib/api/types';

const MEMBER_COLORS = ['#FFC53D', '#7FE3E0', '#FF8FB8', '#7ED957', '#C9A7FF', '#FFA98A'];

export type MemberVisual = { userId: string; name: string; initial: string; color: string };

export function memberVisuals(members: readonly Member[]): MemberVisual[] {
	return members.map((member, index) => ({
		userId: member.userId,
		name: member.name,
		initial: initialOf(member.name),
		color: MEMBER_COLORS[index % MEMBER_COLORS.length]
	}));
}

export function initialOf(name: string): string {
	return (name.trim().charAt(0) || '?').toUpperCase();
}

export function colorAt(index: number): string {
	return MEMBER_COLORS[index % MEMBER_COLORS.length];
}

/** Assignee cycle used by the chore pills: Alle → first member → … → last member → Alle. */
export function nextAssignee(
	members: readonly Member[],
	current: string | null | undefined
): string | null {
	if (!current) return members[0]?.userId ?? null;
	const index = members.findIndex((m) => m.userId === current);
	return index >= 0 && index + 1 < members.length ? members[index + 1].userId : null;
}
